import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'fc-text-area-input',
  templateUrl: './fc-text-area-input.component.html',
  styleUrls: ['./fc-text-area-input.component.scss']
})
export class FcTextAreaInputComponent {

  @Input()
  public control: FormControl;

  @Input()
  public label: string;

  @Input()
  public requiredMark = false;

  @Input()
  public maxLength = null;

  @Input()
  public translateErrorPrefix: string;

  constructor() {
  }

}
